var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjecao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 16.0005,
    cy: 16,
    r: 2.13333,
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C16.336 1 16.6695 1.01105 17 1.0328V0.030742C16.6693 0.0103478 16.3358 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16H31Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0005 5.37925C16.6713 5.34865 16.3378 5.33301 16.0007 5.33301C10.1096 5.33301 5.33398 10.1086 5.33398 15.9997C5.33398 21.8907 10.1096 26.6663 16.0007 26.6663C21.8916 26.6663 26.6671 21.8909 26.6673 16H25.6673C25.6671 21.3386 21.3393 25.6663 16.0007 25.6663C10.6619 25.6663 6.33398 21.3384 6.33398 15.9997C6.33398 10.6609 10.6619 6.33301 16.0007 6.33301C16.3383 6.33301 16.6718 6.35031 17.0005 6.38409V5.37925Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9995 9.67726C16.6737 9.62615 16.3398 9.59961 15.9996 9.59961C12.465 9.59961 9.59961 12.465 9.59961 15.9996C9.59961 19.5342 12.465 22.3996 15.9996 22.3996C19.5341 22.3996 22.3994 19.5344 22.3996 16H21.3996C21.3994 18.9822 18.9818 21.3996 15.9996 21.3996C13.0173 21.3996 10.5996 18.9819 10.5996 15.9996C10.5996 13.0173 13.0173 10.5996 15.9996 10.5996C16.3412 10.5996 16.6755 10.6313 16.9995 10.692V9.67726Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 33",
    x1: 15.4591,
    y1: 16.4914,
    x2: 26.5273,
    y2: 6.24203,
    stroke: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M25.5996 4.26665V6.93332H28.2663L31.4663 4.26665H28.2663V1.06665L25.5996 4.26665Z",
    fill: "#D91F05"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjecao);
export default __webpack_public_path__ + "static/media/projecao.1209b8bef248b34e2a6e154b672fe11e.svg";
export { ForwardRef as ReactComponent };